import * as Types from '../../../generated/graphql.types';

import gql from 'graphql-tag';
import { CoursePreviewFragmentDoc, UserPreviewFragmentDoc } from '../../_shared/fragments.generated';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateUserWithUserGroupIdMutationVariables = Types.Exact<{
  input: Types.CreateUserWithUserGroupIdInput;
}>;


export type CreateUserWithUserGroupIdMutation = { __typename?: 'MutationRoot', createUserWithUserGroupId: { __typename?: 'CreateUserWithUserGroupPayload', password?: string | null, error?: string | null } };

export type UserGroupQueryVariables = Types.Exact<{
  input: Types.Scalars['String'];
}>;


export type UserGroupQuery = { __typename?: 'QueryRoot', userGroup: { __typename?: 'UserGroup', id: string, name: string, courses: Array<{ __typename?: 'Course', id: string, name: string, assetId: number, updatedAt: string, updatedBy: string, routeChangeAlert?: { __typename?: 'RouteChangeAlert', courseId: string, archiveFilePath: string, createdAt: string } | null }>, users: Array<{ __typename?: 'User', id: string, name: string }> }, appConfig: { __typename?: 'AppConfig', routeChangeAlert: boolean } };


export const CreateUserWithUserGroupIdDocument = gql`
    mutation createUserWithUserGroupId($input: CreateUserWithUserGroupIdInput!) {
  createUserWithUserGroupId(input: $input) {
    password
    error
  }
}
    `;

export function useCreateUserWithUserGroupIdMutation() {
  return Urql.useMutation<CreateUserWithUserGroupIdMutation, CreateUserWithUserGroupIdMutationVariables>(CreateUserWithUserGroupIdDocument);
};
export const UserGroupDocument = gql`
    query UserGroup($input: String!) {
  userGroup(userGroupId: $input) {
    id
    name
    courses {
      ...CoursePreview
    }
    users {
      ...UserPreview
    }
  }
  appConfig {
    routeChangeAlert
  }
}
    ${CoursePreviewFragmentDoc}
${UserPreviewFragmentDoc}`;

export function useUserGroupQuery(options: Omit<Urql.UseQueryArgs<UserGroupQueryVariables>, 'query'>) {
  return Urql.useQuery<UserGroupQuery, UserGroupQueryVariables>({ query: UserGroupDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateUserWithUserGroupIdMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ createUserWithUserGroupId })
 *   )
 * })
 */
export const mockCreateUserWithUserGroupIdMutation = (resolver: ResponseResolver<GraphQLRequest<CreateUserWithUserGroupIdMutationVariables>, GraphQLContext<CreateUserWithUserGroupIdMutation>, any>) =>
  graphql.mutation<CreateUserWithUserGroupIdMutation, CreateUserWithUserGroupIdMutationVariables>(
    'createUserWithUserGroupId',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUserGroupQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ userGroup, appConfig })
 *   )
 * })
 */
export const mockUserGroupQuery = (resolver: ResponseResolver<GraphQLRequest<UserGroupQueryVariables>, GraphQLContext<UserGroupQuery>, any>) =>
  graphql.query<UserGroupQuery, UserGroupQueryVariables>(
    'UserGroup',
    resolver
  )
